// ==========================================================================
// CACTUS KNIGHT — Trust-Info Slide-in-Panel
// Klick auf eines der 4 Vertrauens-Icons im Footer öffnet ein Panel von
// rechts mit einer Erläuterung zum jeweiligen Versprechen.
// ==========================================================================

const CK_TRUST_CONTENT = {
  versand: {
    title: "Schneller & Sicherer Versand",
    icon: '<svg viewBox="0 0 24 24"><rect x="1" y="7" width="14" height="10"/><path d="M15 10h4l3 3v4h-7z"/><circle cx="6" cy="19" r="1.6"/><circle cx="17.5" cy="19" r="1.6"/><path d="M3 4h2"/></svg>',
    items: [
      "Deine Bestellung wird in der Regel innerhalb von 24 Stunden an einem Werktag versendet.",
      "Du erhältst nach dem Versand eine E-Mail mit Sendungsverfolgung, sobald das Paket unterwegs ist.",
      "Alle Sendungen sind versichert und werden mit Sendungsverfolgung verschickt.",
      'Alle Infos zu Lieferzeiten findest du auch auf unserer <a href="/pages/versand">Versandseite</a>.',
    ],
  },
  gratisversand: {
    title: "Gratis Versand",
    icon: '<svg viewBox="0 0 24 24"><path d="M21 8 12 3 3 8l9 5 9-5Z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>',
    items: [
      "Der Versand ist für alle Bestellungen innerhalb Deutschlands und der EU komplett kostenlos – ganz ohne Mindestbestellwert.",
      "Keine versteckten Kosten: Der Preis, den du im Warenkorb siehst, ist der Preis, den du zahlst.",
      'Details zu internationalem Versand findest du auf unserer <a href="/pages/versand">Versandseite</a>.',
    ],
  },
  madeingermany: {
    title: "Made in Germany",
    icon: '<svg viewBox="0 0 24 24"><path d="M5 3v18"/><path d="M5 4h14l-3 4 3 4H5"/></svg>',
    items: [
      "Jedes Paar wird in unserer Werkstatt in Deutschland von Hand gefertigt.",
      "Wir setzen auf massives Eichenholz und pulverbeschichteten Stahl statt Massenware.",
      "Jedes Produkt wird vor dem Versand einzeln geprüft, bevor es dich erreicht.",
    ],
  },
  garantie: {
    title: "2 Jahre Garantie",
    icon: '<svg viewBox="0 0 24 24"><path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg>',
    items: [
      "Wir geben 2 Jahre Garantie auf Material und Verarbeitung ab Kaufdatum.",
      "Solltest du einen Materialfehler feststellen, kontaktiere einfach unseren Support.",
      'Mehr dazu unter <a href="/pages/faq">Häufige Fragen</a> oder direkt über <a href="/pages/returns">Retouren &amp; Umtausch</a>.',
    ],
  },
};

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("trust-drawer-overlay");
  const drawer = document.getElementById("trust-drawer");
  const closeBtn = document.getElementById("trust-drawer-close");
  const titleEl = document.getElementById("trust-drawer-title");
  const iconEl = document.getElementById("trust-drawer-icon");
  const bodyEl = document.getElementById("trust-drawer-body");
  const triggers = document.querySelectorAll("[data-trust]");

  if (!overlay || !drawer || triggers.length === 0) return;

  function openDrawer(key) {
    const data = CK_TRUST_CONTENT[key];
    if (!data) return;

    titleEl.textContent = data.title;
    iconEl.innerHTML = data.icon;
    bodyEl.innerHTML = `<ul>${data.items.map((i) => `<li>${i}</li>`).join("")}</ul>`;

    overlay.removeAttribute("hidden");
    drawer.removeAttribute("hidden");
    drawer.setAttribute("aria-hidden", "false");
    // Doppeltes rAF, damit der Browser den Ausgangszustand sicher gerendert
    // hat, bevor die Transition zum offenen Zustand startet (sonst "springt"
    // das Panel manchmal ohne sichtbare Animation direkt auf).
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        overlay.classList.add("is-visible");
        drawer.classList.add("is-open");
      });
    });
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    overlay.classList.remove("is-visible");
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setTimeout(() => {
      overlay.setAttribute("hidden", "");
      drawer.setAttribute("hidden", "");
    }, 600);
  }

  triggers.forEach((btn) => {
    btn.addEventListener("click", () => openDrawer(btn.dataset.trust));
  });

  closeBtn && closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
  });
});
